import BasePage from './BasePage';
import { Box, Container, Typography, Paper, Breadcrumbs, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function RefundPolicy() {
  return (
    <BasePage
      title="Refund Policy | CribCritic AI"
      description="CribCritic AI's refund policy for premium subscriptions"
      keywords="refund policy, subscription, cancellation"
      canonicalUrl="https://cribcritic.ai/refunds"
    >
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link 
            component={RouterLink} 
            to="/" 
            underline="hover" 
            color="inherit"
            zIndex={2001}
            sx={{ 
              '&:hover': { 
                color: 'primary.main',
                cursor: 'pointer' 
              },
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
              Home
            </Box>
          </Link>
          <Typography color="text.primary">Refund Policy</Typography>
        </Breadcrumbs>
        
        <Paper elevation={2} sx={{ p: 4, borderRadius: 2, textAlign: 'left' }}>          
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            Refund Policy
          </Typography>
          
          <Typography variant="h6" component="h2" sx={{ mt: 4, mb: 2 }}>
            All Sales Are Final
          </Typography>
          
          <Typography paragraph>
            All purchases and subscription payments for CribCritic AI services are final and non-refundable.
          </Typography>
          
          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" component="h2" sx={{ mt: 4, mb: 2 }}>
            Questions About Your Purchase
          </Typography>
          
          <Typography paragraph>
            If you have any questions or concerns about your purchase or subscription, please contact our customer support team at <Link href="mailto:support@cribcritic.ai">support@cribcritic.ai</Link>. Our team will be happy to assist you with any inquiries regarding your account or subscription.
          </Typography>
          
          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" component="h2" sx={{ mt: 4, mb: 2 }}>
            Subscription Cancellations
          </Typography>
          
          <Typography paragraph>
            While we do not offer refunds, you may cancel your subscription at any time to prevent future billing. After cancellation, you will continue to have access to premium features until the end of your current billing period.
          </Typography>
          
          <Typography paragraph sx={{ mt: 4, fontStyle: 'italic' }}>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
        </Paper>
      </Container>
    </BasePage>
  );
}

export default RefundPolicy;